module.exports = __webpack_public_path__ + "img/coding-test-In-active-tab.a4c70888.svg";